import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Typography, Button, TextField } from "@material-ui/core";
import _ from "lodash";
export default (props) => {
    const [qualification, setQualification] = useState(props.qualification);
    const [qualificationTitle, setQualificationTitle] = useState(
        _.get(props.qualification, "qualification_title") || ""
    );
    const [postfix, setPostFix] = useState(qualificationTitle.split(" -")[1]);
    let prefix = qualificationTitle.split(" -")[0];

    useEffect(() => {
        setQualification(props.qualification);
        setQualificationTitle(
            _.get(props.qualification, "qualification_title") || ""
        );
        setPostFix(
            (_.get(props.qualification, "qualification_title") || "").split(
                " -"
            )[1]
        );
    }, [props.qualification]);
    return (
        <Modal isOpen={props.isOpen}>
            <ModalHeader>Edit Custom Qualification</ModalHeader>
            {qualification && (
                <ModalBody>
                    <div style={{ display: "flex" }}>
                        <Typography
                            style={{ paddingTop: 20, marginRight: 10 }}
                            variant="subtitle2"
                        >
                            <b>{prefix}:</b>
                        </Typography>
                        <TextField
                            style={{
                                minWidth: 300,
                            }}
                            label={`Qualification Title ${
                                qualification.qualification_title === ""
                                    ? "(Mandatory)"
                                    : ""
                            }`}
                            onChange={(event) => {
                                setPostFix(event.target.value);
                                setQualification({
                                    ...qualification,
                                    qualification_title: `${prefix} -${event.target.value}`,
                                });
                            }}
                            value={postfix}
                        />
                    </div>
                </ModalBody>
            )}
            <ModalFooter>
                <Button
                    onClick={() => props.setModalState()}
                    variant="contained"
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => {
                        props.editCustomQualification(qualification);
                        props.setModalState();
                    }}
                    variant="contained"
                    color="primary"
                >
                    Submit
                </Button>
            </ModalFooter>
        </Modal>
    );
};
